"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lighter = void 0;

var Utils_1 = require("../../Utils");

var Enums_1 = require("../../Enums");

var ParticlesInteractorBase_1 = require("../../Core/ParticlesInteractorBase");

var Lighter = /*#__PURE__*/function (_ParticlesInteractorB) {
  _inherits(Lighter, _ParticlesInteractorB);

  var _super = _createSuper(Lighter);

  function Lighter(container) {
    _classCallCheck(this, Lighter);

    return _super.call(this, container);
  }

  _createClass(Lighter, [{
    key: "interact",
    value: function interact(particle) {
      var container = this.container;
      var options = container.actualOptions;

      if (options.interactivity.events.onHover.enable && container.interactivity.status === "mousemove") {
        var mousePos = this.container.interactivity.mouse.position;

        if (mousePos) {
          container.canvas.drawParticleShadow(particle, mousePos);
        }
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var mouse = container.interactivity.mouse;
      var events = container.actualOptions.interactivity.events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      return Utils_1.isInArray(Enums_1.HoverMode.light, hoverMode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return Lighter;
}(ParticlesInteractorBase_1.ParticlesInteractorBase);

exports.Lighter = Lighter;